import { createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "@app/components/ErrorBoundary";

import Login from "@pages/Login";
import GuestLayout from "@layouts/GuestLayout";
import AuthLayout from "@layouts/AuthLayout";
import { PRIVATE_PAGES, PUBLIC_PAGES } from "./pages";
import NotFoundPage from "@pages/NotFoundPage";
import BlogMutation from "@pages/BlogMutation";
import ProductMutation from "@pages/ProductMutation";
import Products from "@pages/Products";
import Blogs from "@pages/Blogs";
import Recipes from "@pages/Recipes";
import RecipeMutation from "@pages/RecipeMutation";
import Messages from "@pages/Messages";
import Mark from "@pages/Marks";
import MarkMutation from "@pages/MarkMutation";
import ConfigMutation from "@pages/ConfigMutation";
import Market from "@pages/Markets";
import MarketMutation from "@pages/MarketMutation";
import Ingredients from "@pages/Ingredients";
import IngredientMutation from "@pages/IngredientsMutation";
import Categories from "@pages/Categories";
import CategoryMutation from "@pages/CategoryMutation";
import Teams from "@pages/Team";
import TeamMutation from "@pages/TeamMutation";
import Faqs from "@pages/Faqs";
import FaqMutation from "@pages/FaqMutation";
import TeamOrdering from "@pages/TeamOrdering";
import ProductOrdering from "@pages/ProductOrdering";
import FaqOrdering from "@pages/FaqOrdering";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ErrorBoundary>
        <AuthLayout />
      </ErrorBoundary>
    ),
    children: [
      {
        path: PRIVATE_PAGES.BLOGS,
        element: <Blogs />,
      },
      {
        path: PRIVATE_PAGES.CREATE_BLOGS,
        element: <BlogMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_BLOG,
        element: <BlogMutation />,
      },
      {
        path: PRIVATE_PAGES.RECIPES,
        element: <Recipes />,
      },
      {
        path: PRIVATE_PAGES.CREATE_RECIPE,
        element: <RecipeMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_RECIPE,
        element: <RecipeMutation />,
      },
      {
        path: PRIVATE_PAGES.PRODUCTS,
        element: <Products />,
      },
      {
        path: PRIVATE_PAGES.CREATE_PRODUCTS,
        element: <ProductMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_PRODUCT,
        element: <ProductMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_PRODCUTS_ORDERING,
        element: <ProductOrdering />,
      },
      {
        path: PRIVATE_PAGES.MESSAGES,
        element: <Messages />,
      },
      {
        path: PRIVATE_PAGES.INGREDIENTS,
        element: <Ingredients />,
      },
      {
        path: PRIVATE_PAGES.CREATE_INGREDIENTS,
        element: <IngredientMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_INGREDIENT,
        element: <IngredientMutation />,
      },
      {
        path: PRIVATE_PAGES.CATEGORIES,
        element: <Categories />,
      },
      {
        path: PRIVATE_PAGES.CREATE_CATEGORIES,
        element: <CategoryMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_CATEGORY,
        element: <CategoryMutation />,
      },
      {
        path: PRIVATE_PAGES.MARKETS,
        element: <Market />,
      },
      {
        path: PRIVATE_PAGES.CREATE_MARKETS,
        element: <MarketMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_MARKET,
        element: <MarketMutation />,
      },
      {
        path: PRIVATE_PAGES.MARKS,
        element: <Mark />,
      },
      {
        path: PRIVATE_PAGES.CREATE_MARKS,
        element: <MarkMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_MARK,
        element: <MarkMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_CONFIG,
        element: <ConfigMutation />,
      },
      {
        path: PRIVATE_PAGES.TEAMS,
        element: <Teams />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_TEAMS_ORDERING,
        element: <TeamOrdering />,
      },
      {
        path: PRIVATE_PAGES.CREATE_TEAMS,
        element: <TeamMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_TEAM,
        element: <TeamMutation />,
      },
      {
        path: PRIVATE_PAGES.FAQS,
        element: <Faqs />,
      },
      {
        path: PRIVATE_PAGES.CREATE_FAQS,
        element: <FaqMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_FAQ,
        element: <FaqMutation />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_FAQ_ORDERING,
        element: <FaqOrdering />,
      },
    ],
  },
  {
    path: "",
    element: <GuestLayout />,
    children: [
      {
        path: PUBLIC_PAGES.LOGIN,
        element: <Login />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default router;
